import { Builder } from '@builder.io/react'

import {
  iconOptions,
  entryOptions,
  backgroundColorOptions,
} from '../../components/BuilderComponents/builderUtils/constants'
import {
  CTAButton,
  CTABlock,
  LPHero,
  FeaturesBlock,
  LPTestimonials,
  LPFAQs,
  LPComparisonChart,
  TextAndMediaBlock,
  KlaviyoEmbed,
} from '../../components/BuilderComponents' // was getting a weird error - Index had been cached and didn't match with index -- so I had to add it

export const registerBuilderComponents = () => {
  Builder.registerComponent(CTAButton, {
    name: 'CTA Button',
    inputs: [
      {
        name: 'ctaLink',
        type: 'string',
        required: true,
        helperText: 'Link to where you want to send the user on click',
      },
      {
        name: 'ctaVariant',
        type: 'boolean',
        defaultValue: false,
        helperText: 'Choose if you want alternate styling for the CTA button',
      },
      {
        name: 'children',
        friendlyName: 'Button Text',
        type: 'string',
        required: true,
      },
      {
        name: 'ctaAnalytics',
        type: 'string',
        friendlyName: 'CTA Button Analytics',
        defaultValue: 'Clicked_Builder CTA',
        helperText: 'Add anything between "Clicked_Builder" and "CTA" to track the CTA click',
      },
    ],
  })

  Builder.registerComponent(CTABlock, {
    name: 'CTA Block',
    inputs: [
      {
        name: 'heading',
        friendlyName: 'Heading Text',
        type: 'string',
        required: true,
      },
      {
        name: 'description',
        friendlyName: 'Description Text',
        type: 'longText',
        required: false,
      },
      {
        name: 'cta1Variant',
        type: 'boolean',
        friendlyName: 'CTA 1 Use Variant',
        defaultValue: 'false',
        helperText: 'Choose to use alternate styling for the CTA button',
      },

      {
        name: 'cta1Text',
        type: 'string',
        friendlyName: 'CTA 1 Button Text',
        defaultValue: 'Shop Frame',
      },
      {
        name: 'cta1Link',
        type: 'string',
        friendlyName: 'CTA 1 Button Link',
        defaultValue: '/frame',
        helperText: 'Link to where you want to send the user on click',
      },
      {
        name: 'cta1Analytics',
        type: 'string',
        friendlyName: 'CTA 1 Button Analytics',
        defaultValue: 'Clicked_Builder CTA',
        helperText: 'Add anything between "Clicked_Builder" and "CTA" to track the CTA click',
      },
      {
        name: 'hasDualCta',
        type: 'boolean',
        friendlyName: 'Add a second CTA',
      },

      {
        name: 'cta2Variant',
        type: 'boolean',
        friendlyName: 'CTA 2 Use Variant',
        defaultValue: 'false',
        helperText: 'Choose to use alternate styling for the CTA button',
        showIf: (options) => options.get('hasDualCta') === true,
      },

      {
        name: 'cta2Text',
        type: 'string',
        friendlyName: 'CTA 2 Button Text',
        defaultValue: 'Shop Calendar',
        showIf: (options) => options.get('hasDualCta') === true,
      },
      {
        name: 'cta2Link',
        type: 'string',
        friendlyName: 'CTA 2 Button Link',
        defaultValue: '/calendar',
        helperText: 'Link to where you want to send the user on click',
        showIf: (options) => options.get('hasDualCta') === true,
      },
      {
        name: 'cta2Analytics',
        type: 'string',
        friendlyName: 'CTA 2 Button Analytics',
        defaultValue: 'Clicked_Builder CTA',
        helperText: 'Add anything between "Clicked_Builder" and "CTA" to track the CTA click',
        showIf: (options) => options.get('hasDualCta') === true,
      },
    ],
  })

  Builder.registerComponent(LPHero, {
    name: 'landingHero',
    friendlyName: 'Landing Hero',
    inputs: [
      {
        name: 'isVideo',
        type: 'boolean',
        friendlyName: 'Use Video',
        defaultValue: false,
      },
      {
        name: 'mp4VideoUrl',
        type: 'string',
        friendlyName: 'Desktop Video URL',
        showIf: (options) => options.get('isVideo') === true,
      },

      {
        name: 'heroImageUrl',
        type: 'string',
        defaultValue:
          'https://cdn.builder.io/api/v1/image/assets%2Fb0fdb13eaaac4a18820508d774ca5eba%2F2dc0bd91b99842518568f4f0e4162939',
        friendlyName: 'Desktop Image URL',
        showIf: (options) => options.get('isVideo') === false,
      },

      {
        name: 'heroImgAlt',
        type: 'string',
        friendlyName: 'Image Alt Text',
        showIf: (options) => options.get('isVideo') === false,
      },

      {
        name: 'headingCopy',
        type: 'string',
        defaultValue: 'Look at me!',
        friendlyName: 'Heading Text',
        required: true,
      },
      {
        name: 'subHeadlineCopy',
        type: 'longText',
        friendlyName: 'Sub Headline Text',
      },

      {
        name: 'cta1Variant',
        type: 'boolean',
        friendlyName: 'CTA 1 Use Variant',
        defaultValue: 'false',
        helperText: 'Choose to use alternate styling for the CTA button',
      },

      {
        name: 'cta1Text',
        type: 'string',
        friendlyName: 'CTA 1 Button Text',
      },
      {
        name: 'cta1Link',
        type: 'string',
        friendlyName: 'CTA 1 Button Link',
      },
      {
        name: 'cta1Analytics',
        type: 'string',
        friendlyName: 'CTA 1 Button Analytics',
        defaultValue: 'Clicked_Builder CTA',
        helperText: 'Add anything between "Clicked_Builder" and "CTA" to track the CTA click',
      },
      {
        name: 'hasDualCta',
        type: 'boolean',
        friendlyName: 'Add a second CTA',
      },

      {
        name: 'cta2Variant',
        type: 'boolean',
        friendlyName: 'CTA 2 Use Variant',
        defaultValue: 'false',
        helperText: 'Choose to use alternate styling for the CTA button',
        showIf: (options) => options.get('hasDualCta') === true,
      },

      {
        name: 'cta2Text',
        type: 'string',
        friendlyName: 'CTA 2 Button Text',
        showIf: (options) => options.get('hasDualCta') === true,
      },
      {
        name: 'cta2Link',
        type: 'string',
        friendlyName: 'CTA 2 Button Link',
        showIf: (options) => options.get('hasDualCta') === true,
      },
      {
        name: 'cta2Analytics',
        type: 'string',
        friendlyName: 'CTA 2 Button Analytics',
        defaultValue: 'Clicked_Builder CTA',
        helperText: 'Add anything between "Clicked_Builder" and "CTA" to track the CTA click',
        showIf: (options) => options.get('hasDualCta') === true,
      },
    ],
  })

  Builder.registerComponent(FeaturesBlock, {
    name: 'featuresBlock',
    friendlyName: 'Features Block',
    inputs: [
      {
        name: 'sectionTitle',
        type: 'string',
        friendlyName: 'Block Title',
        required: true,
      },
      {
        name: 'featureItems',
        type: 'list',
        friendlyName: 'Feature Items',
        defaultValue: [
          {
            image:
              'https://cdn.builder.io/api/v1/image/assets/7631c00d61004b77a9517c3d27507da8/ee190c7f368d7e0329887f68389965e60d3306ca?placeholderIfAbsent=true',
            title: 'Test Feature 1',
            description: 'Your text will appear here',
            alt: 'accessibility',
          },
        ],
        subFields: [
          {
            name: 'image',
            type: 'string',
            friendlyName: 'Icon URL (SVG Preferred)',
            required: true,
          },
          {
            name: 'title',
            type: 'string',
            friendlyName: 'Feature Title',
            required: true,
          },
          {
            name: 'description',
            type: 'longText',
            friendlyName: 'Feature Description',
            required: true,
          },
          {
            name: 'alt',
            type: 'string',
            friendlyName: 'Alt Text',
          },
        ],
      },
    ],
  })

  Builder.registerComponent(LPTestimonials, {
    name: 'LPTestimonials',
    friendlyName: 'Testimonials',
    inputs: [
      {
        name: 'title',
        type: 'string',
        friendlyName: 'Title',
        required: true,
      },
      {
        name: 'testimonials',
        type: 'list',
        friendlyName: 'Testimonials',
        defaultValue: [
          {
            title: 'Testimonial 1',
            text: 'This is a test testimonial',
            image:
              'https://cdn.builder.io/api/v1/image/assets%2Fb0fdb13eaaac4a18820508d774ca5eba%2F9d7701f46051402893c64c82a8bf8fee',
            name: 'John Doe',
            location: 'New York, NY',
            household: '2',
            starRating: 5,
          },
        ],

        subFields: [
          { name: 'text', type: 'longText', friendlyName: 'Quote', required: true },
          { name: 'image', type: 'string', friendlyName: 'Image URL', required: true },
          { name: 'name', type: 'string', friendlyName: 'Name', required: true },
          { name: 'location', type: 'string', friendlyName: 'Location' },
          { name: 'household', type: 'string', friendlyName: 'Household' },
          { name: 'useStars', type: 'boolean', friendlyName: 'Use Stars' },
          {
            name: 'starRating',
            type: 'number',
            friendlyName: 'Star Rating',
            showIf: (options) => options.get('useStars') === true,
          },
        ],
        required: true,
      },
    ],
  })

  Builder.registerComponent(LPFAQs, {
    name: 'LPFAQs',
    friendlyName: 'FAQs',
    inputs: [
      {
        name: 'sections',
        type: 'list',
        friendlyName: 'Sections',
        defaultValue: [
          {
            title: 'Section 1',
            content: [{ question: 'Question 1', answer: 'Answer 1' }],
          },
        ],
        subFields: [
          { name: 'title', type: 'string', friendlyName: 'Section Title', required: true },
          {
            name: 'content',
            type: 'list',
            friendlyName: 'Content',
            subFields: [
              { name: 'question', type: 'string', friendlyName: 'Question', required: true },
              { name: 'answer', type: 'longText', friendlyName: 'Answer', required: true },
              { name: 'addLink', type: 'boolean', friendlyName: 'Add Link' },
              {
                name: 'text',
                type: 'string',
                friendlyName: 'Link Text',
                helperText: 'Will only appear at the end of a line',
                showIf: (options) => options.get('addLink') === true,
              },
              {
                name: 'link',
                type: 'string',
                friendlyName: 'URL',
                showIf: (options) => options.get('addLink') === true,
              },
              {
                name: 'punctuation',
                type: 'string',
                friendlyName: 'Punctuation',
                helperText: 'Will appear after Link Text',
                showIf: (options) => options.get('addLink') === true,
              },
              {
                name: 'placement',
                type: 'number',
                friendlyName: 'Placement',
                helperText: 'Will dictate where link appears based on line endings',
                showIf: (options) => options.get('addLink') === true,
              },
            ],
            required: true,
          },
        ],
        required: true,
      },
    ],
  })

  // Currently builder cannot coerce constants and variables in the showIf function -- hence the hardcoded values below
  const { greenCheck, darkCheck, xIcon, custom } = iconOptions
  const iconOptionsArray = [greenCheck, darkCheck, xIcon, custom]
  const { iconOnly, textOnly, iconAndText } = entryOptions
  const entryOptionsArray = [iconOnly, textOnly, iconAndText]

  Builder.registerComponent(LPComparisonChart, {
    name: 'LPComparisonChart',
    friendlyName: 'Comparison Chart',
    inputs: [
      {
        name: 'title',
        type: 'string',
        friendlyName: 'Title',
        required: true,
        defaultValue: 'Sad, Empty Comparison Chart',
      },
      {
        name: 'subtitle',
        type: 'string',
        friendlyName: 'Subtitle',
      },
      {
        name: 'competitionName',
        type: 'string',
        friendlyName: 'Competition Name',
        required: true,
      },
      {
        name: 'features',
        type: 'list',
        friendlyName: 'Features',
        subFields: [
          { name: 'featureName', type: 'string', friendlyName: 'Feature Name', required: true },
          {
            name: 'skylightFeatureEntry',
            type: 'string',
            friendlyName: 'Skylight Feature Entry',
            enum: entryOptionsArray,
            defaultValue: iconOnly,
            required: true,
          },
          {
            name: 'skylightEntryIcon',
            type: 'string',
            friendlyName: 'Skylight Entry Icon',
            enum: iconOptionsArray,
            defaultValue: greenCheck,
            showIf: (options) => {
              const slResp = options.get('skylightFeatureEntry')
              const shouldWeShow = slResp === 'Icon_Only' || slResp === 'Icon_and_Text' // Would be great to use imported values here, but builder.io can't coerce anything but a hardCoded string as of builder/Reactv8.1.2 and builder/gatsby@2.0.5
              return shouldWeShow
            },
          },
          {
            name: 'skylightEntryIconUrl',
            type: 'string',
            friendlyName: 'Skylight Entry Icon Url',
            showIf: (options) => options.get('skylightEntryIcon') === 'Custom',
          },
          {
            name: 'skylightEntryText',
            type: 'string',
            friendlyName: 'Skylight Entry Text',
            showIf: (options) => {
              const slResp = options.get('skylightFeatureEntry')
              const shouldWeShow = slResp === 'Text_Only' || slResp === 'Icon_and_Text'
              return shouldWeShow
            },
          },
          {
            name: 'competitionFeatureEntry',
            type: 'string',
            friendlyName: 'Competition Feature Entry',
            enum: entryOptionsArray,
            defaultValue: iconOnly,
            required: true,
          },
          {
            name: 'competitionEntryIcon',
            type: 'string',
            friendlyName: 'Competition Entry Icon',
            enum: iconOptionsArray,
            defaultValue: darkCheck,
            showIf: (options) => {
              const compResp = options.get('competitionFeatureEntry')
              return compResp === 'Icon_Only' || compResp === 'Icon_and_Text'
            },
          },
          {
            name: 'competitionEntryIconUrl',
            type: 'string',
            friendlyName: 'Competition Entry Icon Url',
            showIf: (options) => options.get('competitionEntryIcon') === 'Custom',
          },
          {
            name: 'competitionEntryText',
            type: 'string',
            friendlyName: 'Competition Entry Text',
            showIf: (options) => {
              const compResp = options.get('competitionFeatureEntry')
              return compResp === 'Text_Only' || compResp === 'Icon_and_Text'
            },
          },
        ],
        required: true,
      },
    ],
  })

  const backgroundColorOptionsArray = Object.values(backgroundColorOptions)

  Builder.registerComponent(TextAndMediaBlock, {
    name: 'TextAndMediaBlock',
    friendlyName: 'Text and Media Block',
    inputs: [
      {
        name: 'backgroundColor',
        type: 'string',
        friendlyName: 'Background Color',
        enum: backgroundColorOptionsArray,
        defaultValue: 'Builder_Cream',
        helperText: 'Choose a background color for the block',
      },

      {
        name: 'heading',
        type: 'string',
        friendlyName: 'Heading',
        defaultValue: 'Heading',
        required: true,
      },
      {
        name: 'useBullets',
        type: 'boolean',
        friendlyName: 'Use Bullet List',
        defaultValue: false,
        helperText: `Choose if you'd rather a bullet list for the description`,
      },
      {
        name: 'description',
        type: 'string',
        friendlyName: 'Description',
        showIf: (options) => options.get('useBullets') === false,
      },
      {
        name: 'descriptionList',
        type: 'list',
        friendlyName: 'Description Items',
        defaultValue: [
          {
            descriptionItem: 'List_Item_Text',
          },
        ],
        showIf: (options) => options.get('useBullets') === true,
        subFields: [
          {
            name: 'descriptionItem',
            type: 'string',
            friendlyName: 'Description Item Text',
            required: true,
          },
        ],
      },
      {
        name: 'useCTA',
        type: 'boolean',
        friendlyName: 'Show CTA',
        required: true,
        defaultValue: false,
      },

      {
        name: 'ctaVariant',
        type: 'boolean',
        friendlyName: 'CTA Variant',
        defaultValue: false,
        helperText: 'Choose if you want alternate styling for the CTA button',
        showIf: (options) => options.get('useCTA') === true,
      },

      {
        name: 'ctaText',
        type: 'string',
        friendlyName: 'CTA Text',
        showIf: (options) => options.get('useCTA') === true,
      },
      {
        name: 'ctaLink',
        type: 'string',
        friendlyName: 'CTA Link',
        helperText: 'Link to where you want to send the user on click',
        showIf: (options) => options.get('useCTA') === true,
      },

      {
        name: 'cta1Analytics',
        type: 'string',
        friendlyName: 'CTA 1 Button Analytics',
        defaultValue: 'Clicked_Builder CTA',
        helperText: 'Add anything between "Clicked_Builder" and "CTA" to track the CTA click',
        showIf: (options) => options.get('useCTA') === true,
      },

      { name: 'resourceUrl', type: 'string', friendlyName: 'Image or Video URL', required: true },
      {
        name: 'isVideo',
        type: 'boolean',
        friendlyName: 'Use Video',
        required: true,
        defaultValue: false,
      },
      {
        name: 'textLeft',
        type: 'boolean',
        friendlyName: 'Display Text on Left?',
        required: true,
        defaultValue: true,
      },
      { name: 'altText', type: 'string', friendlyName: 'Alt Text' },
    ],
  })

  Builder.registerComponent(KlaviyoEmbed, {
    name: 'KlaviyoEmbed',
    friendlyName: 'Klaviyo Form',
    inputs: [
      {
        name: 'klaviyoFormId',
        type: 'string',
        friendlyName: 'Klaviyo Form ID',
        defaultValue: 'YsSGDz',
        helperText:
          'Must be a valid Klaviyo form ID obtained from Klaviyo. Use ID only -> klaviyo-form-{THIS IS YOUR ID}. Defaults to PoC form',
      },
      {
        name: 'analyticsEvent',
        type: 'string',
        friendlyName: 'Analytics Event',
        defaultValue: 'Clicked_Builder Klaviyo_Form CTA',
        helperText:
          'Defaults to "Clicked_Builder Klaviyo_Form CTA". Add anything between "Clicked_Builder" and "CTA" to track the form submit. Include the word "Klaviyo" to fire facebook "Lead" event',
      },
      {
        name: 'usePocForm',
        type: 'boolean',
        friendlyName: 'Use Proof of Concept Form',
        helperText: 'Choose to remove "Proof of Concept" Label',
        defaultValue: false,
      },
    ],
  })
}
